module.exports = __webpack_public_path__ + "img/face-disappointed.df99a518.svg";